/* Project Import will be here */
import { getErrorObject } from "../../utilities/utils";
import { getSalesReturnProductListApi } from "../../services/salesReturn/productSalesReturn";
import { ISalesReturnProducts } from "models/salesReturnModels";
import Constants from "../../utilities/appConstants";
/* Project Import will be here */

export const types = {
    SALES_RETURN_PRODUCT_LIST_REQUEST: "salesReturnProducts/SALES_RETURN_PRODUCT_LIST_REQUEST",
    SALES_RETURN_PRODUCT_LIST_SUCCESS: "salesReturnProducts/SALES_RETURN_PRODUCT_LIST_SUCCESS",
    SALES_RETURN_PRODUCT_LIST_FAILURE: "salesReturnProducts/SALES_RETURN_PRODUCT_LIST_FAILURE",
    SALES_RETURN_NEXT_PAGE_REQUEST: "salesReturnProducts/SALES_RETURN_NEXT_PAGE_REQUEST",
    SALES_RETURN_SHOW_MORE_PRODUCT_BUTTON_DISABLE: "salesReturnProducts/SALES_RETURN_SHOW_MORE_PRODUCT_BUTTON_DISABLE",
    SALES_RETURN_UPLOAD_FILTER: "salesReturnProducts/SALES_RETURN_UPLOAD_FILTER",
    RESET_SALES_RETURN_PRODUCTS: "salesReturnProducts/RESET_SALES_RETURN_PRODUCTS"
};

const initialFilterState: ISalesReturnProducts = {
    Page: 1,
    FilterLevelCode: "",
    FilterIdList: [],
    AttrFilter: [],
    Sorting: Constants.NAME_ASC,
};

const initialState = {
    filter: initialFilterState,
    isLoading: false,
    data: [],
    count: 0,
    totalCount: 0,
    noOfItemsReceived: 0,
    IsShowShowMoreProductButton: true,
    error: null
};

export const salesReturnProducts = (state = initialState, action) => {
    switch (action.type) {
        case types.SALES_RETURN_PRODUCT_LIST_REQUEST: {
            return {
                ...initialState,
                filter: {
                    ...state.filter,
                    ...action.payload.filter,
                },
                IsShowShowMoreProductButton: true,
                isLoading: true
            };
        }
        case types.SALES_RETURN_PRODUCT_LIST_SUCCESS:
            return {
                ...state,
                ...action.payload,
                error: null,
                isLoading: false
            };
        case types.SALES_RETURN_PRODUCT_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error
            };
        case types.SALES_RETURN_NEXT_PAGE_REQUEST:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    Page: action.payload.nextPage
                },
                error: null,
                isLoading: true
            };
        case types.SALES_RETURN_UPLOAD_FILTER:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    FilterLevelCode: action.payload.filterLevelCode,
                    FilterIdList: action.payload.filterIdList
                },
                data: [],
                error: null,
                isLoading: true
            };
        case types.SALES_RETURN_SHOW_MORE_PRODUCT_BUTTON_DISABLE:
            return {
                ...state,
                filter: {
                    ...state.filter,
                },
                IsShowShowMoreProductButton: action.payload,
                error: null
            };
        case types.RESET_SALES_RETURN_PRODUCTS:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};

/* Get product list based on the applied filer conditions */
export const getSalesReturnProductList = () => {
    return async (dispatch, getState) => {
        /* Get attr filter state */
        const attrFilter = getState().attrFilter;

        /* Check for sorting filter */
        let sortingFilter = attrFilter.selectedSortingFilter;
        if (sortingFilter === Constants.PRICE_ASC || sortingFilter === Constants.PRICE_DESC)
            sortingFilter = initialFilterState.Sorting;

        dispatch({
            type: types.SALES_RETURN_PRODUCT_LIST_REQUEST,
            payload: {
                filter: {
                    ...getState().salesReturnProducts.filter,
                    Page: 1,
                    Sorting: sortingFilter,
                    AttrFilter: attrFilter.selectedAttrFilter
                }
            }
        });
        try {
            /* Get the applied filter */
            const filters = getState().salesReturnProducts.filter;

            /* get sales return products with the applied filter conditions */
            const response = await getSalesReturnProductListApi(filters);
            const payload = {
                data: response.data.Data,
                count: response.data.Count,
                totalCount: response.data.TotalCount,
                noOfItemsReceived: response.data.Data.length,
            };

            dispatch({
                type: types.SALES_RETURN_PRODUCT_LIST_SUCCESS,
                payload
            });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.SALES_RETURN_PRODUCT_LIST_FAILURE));
        }
    }
};

export const applyCatAndSubCatFilter = (levelCode: string, id: number) => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.SALES_RETURN_UPLOAD_FILTER,
            payload: {
                filterLevelCode: levelCode,
                filterIdList: [id]
            }
        });

        dispatch(getSalesReturnProductList());
    }
};

export const resetSalesReturnProducts = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.RESET_SALES_RETURN_PRODUCTS });
    }
};

export const clearCatAndSubCatFilter = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.SALES_RETURN_UPLOAD_FILTER,
            payload: {
                filterLevelCode: "",
                filterIdList: []
            }
        });
    }
};

export const getSalesReturnNextPage = (nextPage) => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.SALES_RETURN_NEXT_PAGE_REQUEST,
            payload: { nextPage }
        });

        try {
            /* Get the applied filter */
            const filters = getState().salesReturnProducts.filter;

            /* get sales return products with the applied filter conditions */
            const response = await getSalesReturnProductListApi(filters);

            if (response.data.Data.length > 0) {
                const oldProducts = getState().salesReturnProducts;
                const payload = {
                    data: [...oldProducts.data, ...response.data.Data],
                    totalCount: response.data.TotalCount,
                    noOfItemsReceived: oldProducts.noOfItemsReceived + response.data.Data.length
                };

                dispatch({
                    type: types.SALES_RETURN_PRODUCT_LIST_SUCCESS,
                    payload
                });
            }
        }
        catch (error) {
            dispatch({
                type: types.SALES_RETURN_SHOW_MORE_PRODUCT_BUTTON_DISABLE,
                payload: false
            });
            dispatch(promiseCatchBlock(error, types.SALES_RETURN_PRODUCT_LIST_FAILURE));
        }
    };
};

/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string) => {
    return (dispatch) => {
        const { message } = getErrorObject(error);
        dispatch({
            type: type,
            payload: { error: message }
        });
    }
};